// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3TxyO","colCheckbox":"styles_colCheckbox__3YEjX"};